<template>
    <div>
        <v-card>
            <v-toolbar dark color="secondary">
                <v-spacer></v-spacer>
                <v-toolbar-title>Public Site Security Admin.</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text dense v-if="publicSiteStatuses">
                <v-layout row>
                    <v-flex xs4 body-2 pt-1>Public Site Status:</v-flex>
                    <v-flex xs8 text-xs-left pt-1 :class="publicSiteStatuses.publicSiteStatus=='Locked'?'red--text ':''">{{ publicSiteStatuses.publicSiteStatus }}</v-flex>
                </v-layout>
                <v-layout row>
                    <v-flex xs4 body-2 pt-1></v-flex>
                    <v-flex xs8 text-xs-left pt-1>{{ publicSiteStatuses.failedLoginsSoFar }}</v-flex>
                </v-layout>
                <v-layout row v-show="showLockedInfo">
                    <v-flex xs4 body-2 pt-1>Public Site Locked Time:</v-flex>
                    <v-flex xs8 text-xs-left pt-1>{{ publicSiteStatuses.lockedDateTime }}</v-flex>
                </v-layout>
                <v-layout row v-show="showLockedInfo">
                    <v-flex xs4 body-2 pt-1>More Failed Login after Site Locked:</v-flex>
                    <v-flex xs8 text-xs-left pt-1>{{ publicSiteStatuses.publicSiteAttemptedLoginAfterShutdown }}</v-flex>
                </v-layout>
                <v-layout row v-show="showLockedInfo">
                    <v-flex xs4 body-2 pt-1></v-flex>
                    <v-flex xs8 text-xs-left pt-1>
                        <v-btn @click="onUnlock" large color="primary">Unlock Public Site</v-btn>
                    </v-flex>
                </v-layout>

            </v-card-text>
        </v-card>
    </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
    data() {
        return {
            publicSiteStatuses: null
        }
    },
    computed: {
        showLockedInfo(){
            return this.publicSiteStatuses && this.publicSiteStatuses.publicSiteStatus == 'Locked'
        }
    },
    methods: {
        ...mapActions('adminPubSiteAdmin', [
            'getPublicSiteStatus',
            'unlockPublicSite'
        ]),
        async onUnlock() {
            if(confirm('Public site may under attack, are you are to reopen?')) {
                await this.unlockPublicSite()
                this.publicSiteStatuses = await this.getPublicSiteStatus()

            }
        }
    },
    async created() {
        this.publicSiteStatuses = await this.getPublicSiteStatus(null)
    },
}
</script>

